import React from 'react';
import type { BenchmarkItem, ValueFormat } from '../../utils/benchmarks';
import { fmtCurrency, fmtInt, fmtPct, fmtPP, fmtRatio, fmtSignedPct } from '../../utils/format';
export function formatValue(v: number, f: ValueFormat): string {
  if (f === 'pct') return fmtPct(v);
  if (f === 'ratio') return fmtRatio(v);
  if (f === 'currency') return fmtCurrency(v);
  return fmtInt(v);
}
export function formatGap(item: BenchmarkItem): string {
  return item.gapKind === 'pp' ? fmtPP(item.gap) : fmtSignedPct(item.gap);
}
export function BenchmarkTable({
  items,
  entityLabel,
  benchLabel
}: {
  items: BenchmarkItem[];
  entityLabel: string;
  benchLabel: string;
}) {
  return <div className="overflow-x-auto" data-id="element-580" data-mp="30vzs3xylnvhy">
      <table className="w-full min-w-[640px] text-[12.5px]" data-id="element-581" data-mp="30ux2dtd0jz3m">
        <thead data-id="element-582" data-mp="k7cgecuxp5wi">
          <tr className="border-b-2 border-navy/70 text-navy" data-id="element-583" data-mp="k6t8zq2wtzwq">
            <th scope="col" className="py-2 pr-3 text-left font-semibold" data-id="element-584" data-mp="k9ffdme2e9dd">Metric</th>
            <th scope="col" className="px-3 py-2 text-right font-semibold" data-id="element-585" data-mp="g5hh1dwkd2ld">{entityLabel}</th>
            <th scope="col" className="px-3 py-2 text-right font-semibold" data-id="element-586" data-mp="3r0c23njy5uz4">{benchLabel}</th>
            <th scope="col" className="px-3 py-2 text-right font-semibold" data-id="element-587" data-mp="3vym3wh06fttp">Gap</th>
            <th scope="col" className="py-2 pl-3 text-left font-semibold" data-id="element-588" data-mp="3x7crektjdln">
              <span className="sr-only" data-id="element-589" data-mp="8vr0nkiz2zgn">Gap bar</span>
            </th>
          </tr>
        </thead>
        <tbody className="tabular-nums" data-id="element-590" data-mp="38aw2r3k008ka">
          {items.map(it => {
          const capped = Math.min(1, Math.abs(it.severity) / 3);
          const neg = it.gap < 0;
          return <tr key={it.id} className="border-b border-line" data-id="element-591" data-mp="3haiu0wj0jxzm">
                <td className="py-2.5 pr-3 text-ink" data-id="element-592" data-mp="3h8y1fcg9ep4e">{it.label}</td>
                <td className="px-3 py-2.5 text-right font-semibold text-navy" data-id="element-593" data-mp="3m2izf4hurj3l">{formatValue(it.entity, it.format)}</td>
                <td className="px-3 py-2.5 text-right text-ink-muted" data-id="element-594" data-mp="2om3i4iv6hvsi">{formatValue(it.benchmark, it.format)}</td>
                <td className={`px-3 py-2.5 text-right font-medium ${neg ? 'text-negative' : 'text-positive'}`} data-id="element-595" data-mp="2tj3n0qgaksi1">{formatGap(it)}</td>
                <td className="w-40 py-2.5 pl-3" data-id="element-596" data-mp="3rxsqxye5g5h6">
                  <div className="relative h-2 w-full rounded-sm bg-canvas" aria-hidden data-id="element-597" data-mp="3rx0uymgn45qd">
                    <span className="absolute inset-y-0 left-1/2 w-px bg-line-strong" data-id="element-598" data-mp="9irxuykwr3e2" />
                    <span className={`absolute inset-y-0 ${neg ? 'right-1/2 rounded-l-sm bg-negative/70' : 'left-1/2 rounded-r-sm bg-positive/70'}`} style={{
                  width: `${capped * 50}%`
                }} data-id="element-599" data-mp="5izj244x8109" />
                  </div>
                </td>
              </tr>;
        })}
        </tbody>
      </table>
    </div>;
}